const white = '#fff'
const gray = {
  200: '#edf2f7',
  300: '#e2e8f0',
  400: '#cbd5e0',
  500: '#a0aec0',
  600: '#718096',
  700: '#4a5568',
  800: '#2d3748',
  900: '#1a202c'
}
//Good
const aqua = {
  100: '#B8E3EC',
  300: '#55BDD4',
  500: '#2A9fBC',
  600: '#0C6F83',
  800: '#134F5F'
}

const magenta = {
  100: '#EEB3D2',
  300: '#E55BA1',
  500: '#EA0A8C',
  600: '#A02065',
  800: '#731546'
}
// const indigo = {
//   100: '#ebf4ff',
//   300: '#a3bffa',
//   500: '#667eea',
//   600: '#5a67d8',
//   800: '#434190'
// }
// const purple = {
//   100: '#faf5ff',
//   300: '#d6bcfa',
//   500: '#9f7aea',
//   600: '#805ad5',
//   800: '#553c9a'
// }
//Good
const blue = {
  100: '#97C9EC',
  300: '#6480C0',
  500: '#4665AF',
  600: '#2A5086',
  800: '#183B68'
}
//Good
const green = {
  100: '#A3D5B0',
  500: '#1E964D'
}
//Good
const red = {
  100: '#F3BBBD',
  500: '#E22028'
}
//Good
//Primary
const alpha = {
  alphaLighter: aqua[100],
  alphaLight: aqua[300],
  alpha: aqua[500],
  alphaDark: aqua[600],
  alphaDarker: aqua[800]
}
//Good
// Secondary
const beta = {
  betaLighter: blue[100],
  betaLight: blue[300],
  beta: blue[500],
  betaDark: blue[600],
  betaDarker: blue[800]
}

// Reserved
const gamma = {}

// Reserved
const psi = {}

//Bad
// Neutral
const omega = {
  omegaLighter: gray[200],
  omegaLight: gray[300],
  omega: gray[500],
  omegaDark: gray[600],
  omegaDarker: gray[800]
}

const defaultColors = {
  text: gray[600],
  article: gray[700],
  heading: gray[800],

  ...alpha,
  ...beta,
  ...gamma,
  ...psi,
  ...omega,

  successLight: green[100],
  success: green[500],
  errorLight: red[100],
  error: red[500],

  readTime: magenta[300],

  white: white,
  background: `#f8f8f8`,
  contentBg: white,
  headerBg: white,
  footerBg: white,

  mute: gray[300],
  highlight: gray[200],

  modes: {
    dark: {
      // Reverse alpha
      alphaLighter: alpha.alphaDarker,
      alphaLight: alpha.alphaDark,
      alphaDark: alpha.alphaLight,
      alphaDarker: alpha.alphaLighter,

      // Reverse beta
      betaLighter: beta.betaDarker,
      betaLight: beta.betaDark,
      betaDark: beta.betaLight,
      betaDarker: beta.betaLighter,

      // Reverse omega
      omegaLighter: omega.omegaDarker,
      omegaLight: omega.omegaDark,
      omegaDark: omega.omegaLight,
      omegaDarker: omega.omegaLighter,

      text: gray[400],
      article: gray[300],
      heading: gray[200],

      background: gray[900],
      contentBg: gray[800],
      headerBg: gray[800],
      footerBg: gray[800],

      mute: gray[600]
    }
  }
};

export default defaultColors;
